import { faComments } from "@fortawesome/pro-duotone-svg-icons/faComments";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_CONVERSATIONS_LINK: Breadcrumb = {
  icon: faComments,
  name: "Conversations",
  to: "/dashboard/conversations",
};
